import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';

class PlusMinus extends React.Component {

	plus() {
		this.props.setValue(this.props.value + this.props.jumpBy);
	}

	minus() {
		this.props.setValue(this.props.value - this.props.jumpBy);
	}

  handleChange(event) {
  	this.props.setValue(event.target.value);
  }

	render() {
    return (
       <span class="input-group">
         <input type="button" value="-" class="button-minus" data-field="quantity" onClick={this.minus.bind(this)}/>
         <input type="number" step="1" style={{ width: (this.props.value + "0").length > 3 ? "48px" : "42px" }} max="" value={this.props.value} name="quantity" class="quantity-field" onChange={this.handleChange.bind(this)}/>
         <input type="button" value="+" class="button-plus" data-field="quantity" onClick={this.plus.bind(this)}/>
       </span>
    );
  }
}

PlusMinus.propTypes = {
  setValue: PropTypes.func,
  value: PropTypes.number,
  jumpBy: PropTypes.number,
};

PlusMinus.defaultProps = {
  jumpBy: 1
};

export default PlusMinus;